<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title :class="['headline', dividerClass + '--text']">{{
          title
        }}</v-list-item-title>
        <v-list-item-subtitle>Informations détaillées</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="d-print-none">
        <v-tooltip bottom>
          <template #activator="data">
            <v-btn icon @click="exportInstance()" v-on="data.on">
              <v-icon>mdi-file-export</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('recherche.export.title.directInstance') }}</span>
        </v-tooltip>
      </v-list-item-action>
      <v-list-item-action class="ml-0 d-print-none">
        <printButton />
      </v-list-item-action>
    </v-list-item>
    <v-form v-model="valid" lazy-validation ref="form">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              filled
              v-model="form.nom"
              :rules="[obligatoireRule(), serveurRule('nom')]"
              :label="$t('instance.detail.form.nom')"
              :background-color="analyseDiff.color['nom']"
              :readonly="control.readonly"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="3" v-if="form.id">
            <v-text-field
              dense
              filled
              v-model="form.id"
              :label="$t('instance.detail.form.id')"
              readonly
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              return-object
              dense
              filled
              :items="listeTypesInstance"
              v-model="form.typeInstance"
              item-text="libelle"
              :label="$t('instance.detail.form.typeInstance')"
              :readonly="control.readonly"
              hide-details="auto"
              :rules="[obligatoireRule(), serveurRule('typeInstance')]"
            >
              <template #selection="{item}">
                {{ item.libelle }}
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-textarea
              dense
              filled
              v-model="form.description"
              :label="$t('instance.detail.form.description')"
              :readonly="control.readonly"
              :rules="[obligatoireRule(), serveurRule('description')]"
              hide-details="auto"
              :background-color="analyseDiff.color['description']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              filled
              v-model="form.urlSharepoint"
              :label="$t('instance.detail.form.urlSharepoint')"
              :rules="[serveurRule('urlSharepoint')]"
              :readonly="control.readonly"
              hide-details="auto"
              :background-color="analyseDiff.color['urlSharepoint']"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-menu
              ref="menuDateDebut"
              v-model="menuValiditeDebut"
              :close-on-content-click="false"
              :return-value.sync="form.dateDebut"
              transition="scale-transition"
              :disabled="control.readonly"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateDebutFormatted"
                  dense
                  filled
                  readonly
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  prepend-inner-icon="event"
                  :rules="[dateRule(), serveurRule('dateDebut')]"
                  :label="$t('instance.detail.form.dateDebut')"
                  :background-color="analyseDiff.color['dateDebut']"
                  :hint="analyseDiff.hint['dateDebut']"
                ></v-text-field>
              </template>
              <v-card flat>
                <v-date-picker v-model="form.dateDebut" no-title scrollable />
                <v-divider :class="dividerClass" />
                <v-card-actions>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuDateDebut.save(form.dateDebut)"
                    >OK</v-btn
                  >
                  <v-btn
                    v-if="form.dateDebut"
                    text
                    color="error"
                    @click="deleteDateDebut"
                    >Supprimer</v-btn
                  >
                  <v-btn text @click="menuValiditeDebut = false">Annuler</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-menu
              ref="menuDateFin"
              v-model="menuValiditeFin"
              :close-on-content-click="false"
              :return-value.sync="form.dateFin"
              transition="scale-transition"
              :disabled="control.readonly"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFinFormatted"
                  dense
                  filled
                  readonly
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  prepend-inner-icon="event"
                  :rules="[dateRule(), serveurRule('dateFin')]"
                  :label="$t('instance.detail.form.dateFin')"
                  :background-color="analyseDiff.color['dateFin']"
                  :hint="analyseDiff.hint['dateFin']"
                ></v-text-field>
              </template>
              <v-card flat>
                <v-date-picker v-model="form.dateFin" no-title scrollable />
                <v-divider :class="dividerClass" />
                <v-card-actions>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuDateFin.save(form.dateFin)"
                    >OK</v-btn
                  >
                  <v-btn
                    v-if="form.dateFin"
                    text
                    color="error"
                    @click="deleteDateFin"
                    >Supprimer</v-btn
                  >
                  <v-btn text @click="menuValiditeFin = false">Annuler</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <!-- Raison de ce div : https://github.com/vuetifyjs/vuetify/issues/8387 -->
                  <v-select
                    v-model="form.referent.id"
                    :items="listeParticipant"
                    :item-text="
                      item =>
                        item.contact.nom +
                        ' ' +
                        item.contact.prenoms +
                        ' (' +
                        item.contact.societe +
                        ')'
                    "
                    item-value="id"
                    :label="$t('instance.detail.form.referent.title')"
                    :readonly="control.readonly"
                    :background-color="analyseDiff.color['referent']"
                    :hint="analyseDiff.hint['referent']"
                    hide-details="auto"
                    dense
                    filled
                    chips
                  >
                    <template #selection="{item}">
                      <v-chip
                        :close="!control.readonly"
                        small
                        color="secondary"
                        @click:close="removeReferent()"
                        >{{
                          item.contact.nom +
                            ' ' +
                            item.contact.prenoms +
                            ' (' +
                            item.contact.societe +
                            ')'
                        }}</v-chip
                      >
                    </template>
                  </v-select>
                </div>
              </template>
              <span>{{ $t('instance.detail.form.referent.detail') }}</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" md="6" sm="12">
            <v-card>
              <v-card-title>
                <v-icon>mdi-account</v-icon>
                {{
                  $tc(
                    'entetes.gestionnaire',
                    form.gestionnaires ? form.gestionnaires.length : 0,
                  )
                }}
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!control.readonly"
                  text
                  small
                  outlined
                  color="secondary"
                  @click="selectGestionnaire"
                  >{{ $t('instance.detail.form.gestionnaires.add') }}
                </v-btn>
                <dialogRechercheParticipantGestionnaire
                  ref="dialogRechercheGestionnaire"
                  mode="gestionnaire"
                  @inputParticipant="valideNouveauContact"
                  @inputGestionnaire="addGestionnaire"
                  :participants="form.participants"
                  :gestionnaires="form.gestionnaires"
                />
              </v-card-title>
              <v-card-text>
                <v-list dense>
                  <template v-for="(gestionnaire, index) in form.gestionnaires">
                    <v-list-item
                      :key="`gestionnaires${gestionnaire.idPersonnePhysique}`"
                      v-show="index < 3 ? true : showAllGestionnaires"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <a
                            @click="
                              detailGestionnaire(
                                gestionnaire.idPersonnePhysique,
                              )
                            "
                          >
                            {{ gestionnaire.libelle }}
                          </a>
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action
                        v-if="
                          analyseDiff.supprime[
                            `gestionnaires[${gestionnaire.idPersonnePhysique}]`
                          ] && !control.readonly
                        "
                      >
                        <v-btn
                          icon
                          :color="
                            colorGestionnaire(gestionnaire.idPersonnePhysique)
                          "
                          @click.stop.capture="
                            annulerSuppression(
                              `gestionnaires[${gestionnaire.idPersonnePhysique}]`,
                            )
                          "
                        >
                          <v-icon>undo</v-icon>
                        </v-btn>
                      </v-list-item-action>

                      <v-list-item-action v-else-if="!control.readonly">
                        <v-btn
                          small
                          icon
                          @click.stop="removeGestionnaire(index)"
                        >
                          <v-icon small>mdi-delete</v-icon></v-btn
                        >
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="
                        gestionnaire &&
                          ((showAllGestionnaires &&
                            index < form.gestionnaires.length - 1) ||
                            index <
                              Math.min(
                                form.gestionnaires.length,
                                nbGestionnaireVisibles,
                              ) -
                                1)
                      "
                      :key="`${gestionnaire.id}`"
                      :class="dividerClass"
                    />
                  </template>
                </v-list>
                <v-btn
                  icon
                  v-if="
                    form.gestionnaires &&
                      form.gestionnaires.length > nbGestionnaireVisibles
                  "
                  v-on:click="showAllGestionnaires = !showAllGestionnaires"
                >
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12" md="12">
        <v-card>
          <v-card-title>
            {{ $tc('entetes.participant', form.participants.length) }}
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchParticipant"
              :label="$t('instance.detail.form.panel.participants.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-subtitle v-if="!control.readonly">
            <v-btn small outlined color="secondary" @click="ajouterParticipant"
              >ajouter un participant</v-btn
            >
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              :sortBy="['contact.nom', 'contact.prenoms']"
              :headers="headers"
              :search="searchParticipant"
              :items="form.participants"
              :custom-filter="filterItems"
              :items-per-page="10"
              :item-class="colorParticipant"
              dense
            >
              <template #item.contact.nom="{item}">
                <router-link :to="$liens().personnePhysique(item.contact.ppid)">
                  {{ item.contact.nom }}
                </router-link>
              </template>
              <template #item.contact.prenoms="{item}">
                <router-link :to="$liens().personnePhysique(item.contact.ppid)">
                  {{ item.contact.prenoms }}
                </router-link>
              </template>
              <template #item.contact.societe="{item}">
                <router-link :to="$liens().personneMorale(item.contact.pmid)">
                  {{ item.contact.societe }}
                </router-link>
              </template>
              <template #item.contact.fonction="{item}">
                {{ item.contact.fonction }}
              </template>
              <template v-if="!control.readonly" #item.actions="{item}">
                <v-icon small @click="supprimerParticipant(item)"
                  >mdi-delete</v-icon
                >
                <v-icon
                  icon
                  color="white"
                  v-if="
                    analyseDiff.supprime[
                      `participants[${form.participants.indexOf(item)}]`
                    ]
                  "
                  @click.stop.capture="
                    annulerSuppression(
                      `participants[${form.participants.indexOf(item)}]`,
                    )
                  "
                  >undo</v-icon
                >
              </template>
              <template v-if="!control.readonly" #item.typeParticipant="{item}">
                <v-select
                  v-model="item.typeParticipant"
                  return-object
                  dense
                  :items="listeTypesParticipant"
                  :item-text="item => item.libelle"
                >
                  {{ item.libelle }}
                </v-select>
              </template>

              <template v-else #item.typeParticipant="{item}">
                {{ item.typeParticipant.libelle }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <dialogRechercheParticipantGestionnaire
          ref="dialogRechercheParticipant"
          mode="participant"
          @inputParticipant="valideNouveauContact"
          @input="addGestionnaire"
          :participants="form.participants"
          :gestionnaires="form.gestionnaires"
          :referent="form.referent.id"
        />

        <v-card-text>
          <footer-rgpd :form="this.form" genre="F" />
        </v-card-text>
        <v-divider :class="dividerClass" />
      </v-col>

      <slot name="zoneBasse" />
    </v-form>
    <slot />

    <v-dialog v-model="waitForExport" persistent max-width="50%">
      <v-card>
        <v-card-title class="accent white--text">
          <v-icon color="white">mdi-clock</v-icon>Export en cours
        </v-card-title>
        <v-card-text class="body-1">
          <p class="pt-4">
            Votre document est en cours de préparation.
          </p>
          <p>
            Veuillez patienter quelques secondes.
          </p>
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            striped
            height="6"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ServeurRule from '@/plugins/mixins/ServeurRule';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import DateFormatter from '@/plugins/mixins/DateFormatter';
import { defaultDiff } from '@/utils/diff.js';
import toasted from '@/utils/toasted';
import moment from 'moment';
import { saveAs } from 'file-saver';
import arraybufferToResponse from '@/utils/errors';

const NAMESPACE = 'instance';

export default {
  mixins: [ServeurRule, ValidationRules, DateFormatter],
  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    };
  },
  props: {
    serverSearch: {
      type: Boolean,
    },

    enums: {
      type: Object,
    },
    form: {
      type: Object,
    },
    control: {
      type: Object,
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
  },
  data() {
    return {
      showAllGestionnaires: false,
      nbGestionnaireVisibles: 3,
      valid: true,
      menuValiditeDebut: null,
      menuValiditeFin: null,
      namespace: NAMESPACE,
      waitForExport: false,
      // Configuration de l'IHM
      searchParticipant: '',
      headers: [
        {
          text: this.$t('recherche.rechercheSimple.instance.list.headers.nom'),
          sortable: true,
          value: 'contact.nom',
        },
        {
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.prenoms',
          ),
          sortable: true,
          value: 'contact.prenoms',
        },
        {
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.societe',
          ),
          sortable: true,
          value: 'contact.societe',
        },
        {
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.fonction',
          ),
          sortable: true,
          value: 'contact.fonction',
        },
        {
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.typeParticipant',
          ),
          sortable: true,
          value: 'typeParticipant',
        },
        {
          sortable: false,
          value: 'actions',
        },
      ],
    };
  },
  computed: {
    listeTypesInstance() {
      if (this.enums.typesInstance.length) {
        return this.enums.typesInstance;
      } else {
        const typesInstance = [];
        if (this.form && this.form.typeInstance) {
          typesInstance.push(this.form.typeInstance);
        }
        return typesInstance;
      }
    },

    listeTypesParticipant() {
      if (this.enums.typesParticipant.length) {
        return this.enums.typesParticipant;
      } else {
        const typesParticipant = [];
        if (this.form && this.form.typesParticipant) {
          typesParticipant.push(this.form.typesParticipant);
        }
        return typesParticipant;
      }
    },

    listeParticipant() {
      function compare(a, b) {
        if (a.contact.nom < b.contact.nom) {
          return -1;
        }
        if (a.contact.nom > b.contact.nom) {
          return 1;
        }
        return 0;
      }
      var participants = JSON.parse(JSON.stringify(this.form.participants));
      participants = participants.map(p => {
        p.id = p.contact.id;
        return p;
      });
      return participants.sort(compare);
    },

    dateDebutISO() {
      if (this.form && this.form.dateDebut) {
        return this.form.dateDebut;
      } else {
        return null;
      }
    },
    dateDebutFormatted() {
      return this.formatDate(this.dateDebutISO);
    },
    dateFinISO() {
      if (this.form && this.form.dateFin) {
        return this.form.dateFin;
      } else {
        return null;
      }
    },
    dateFinFormatted() {
      return this.formatDate(this.dateFinISO);
    },
    dividerClass() {
      if (this.control.enCreation || this.control.enDemandeCreation) {
        return '';
      } else if (
        this.control.enDemandeModification ||
        (!this.control.readonly &&
          !this.control.enDemandeSuppression &&
          !this.enModeReactivation &&
          this.control.edition === 'DIRECT')
      ) {
        return 'accent';
      } else if (this.control.enDemandeSuppression) {
        return 'error';
      } else {
        return '';
      }
    },
    title() {
      if (this.control.enDemandeCreation) {
        return 'Instance : Demande de création';
      } else if (this.control.enDemandeModification) {
        return 'Instance : Demande de modification';
      } else if (this.control.enCreation) {
        return 'Instance : Création';
      } else if (
        !this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.enModeReactivation &&
        this.control.edition === 'DIRECT'
      ) {
        return 'Instance : Modification';
      } else if (this.control.enDemandeSuppression) {
        return 'Instance : Demande de suppression';
      } else {
        return 'Instance';
      }
    },
  },
  watch: {},
  methods: {
    // Gestion des demandes
    colorGestionnaire(id) {
      if (!this.analyseDiff) {
        return null;
      }
      const c = this.analyseDiff.color[`gestionnaires[${id}]`];
      if (c) {
        return c;
      } else {
        return null;
      }
    },
    colorParticipant(item) {
      return (
        this.analyseDiff.color[
          `participants[${this.form.participants.indexOf(item)}]`
        ] ||
        this.analyseDiff.color[
          `participants[${this.form.participants.indexOf(
            item,
          )}].typeParticipant`
        ]
      );
    },
    filterItems(val, search) {
      if (typeof val === 'object') {
        return (
          val.libelle
            .toString()
            .toLowerCase()
            .indexOf(search) !== -1
        );
      }
      return (
        val != null &&
        typeof val !== 'boolean' &&
        val
          .toString()
          .toLowerCase()
          .indexOf(search) !== -1
      );
    },
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },
    getForms() {
      //access aux formulaire à créer
      return [this.$refs.form];
    },
    sauvegarderEdition() {},

    // Gestion des gestionnaires
    detailGestionnaire(idPersonnePhysique) {
      const route = {
        path: `/recherche/recherchesimple/personne-physique/${idPersonnePhysique}`,
        params: {
          id: idPersonnePhysique,
        },
      };
      this.$router.push(route);
    },
    selectGestionnaire() {
      this.$refs.dialogRechercheGestionnaire.show();
    },
    addGestionnaire(personnePhysique) {
      if (
        this.form.gestionnaires
          .flatMap(p => p.idPersonnePhysique)
          .indexOf(personnePhysique.id) == -1
      ) {
        this.form.gestionnaires.push({
          id: personnePhysique.id,
          libelle: personnePhysique.nom + ' ' + personnePhysique.prenoms,
          idPersonnePhysique: personnePhysique.id,
        });
        toasted.info('Contact ajouté comme gestionnaire de l\'instance');
      } else {
        toasted.info('Ce contact est déjà un gestionnaire de l\'instance.');
      }

      // On affiche tous les gestionnaires pour éviter que l'utilisateur ait l'impression qu'il ne s'est rien passé
      this.showAllGestionnaires = true;
    },
    removeGestionnaire(index) {
      this.form.gestionnaires.splice(index, 1);
    },
    removeReferent() {
      this.form.referent.id = null;
    },

    // Gestion des participants
    ajouterParticipant() {
      this.$refs.dialogRechercheParticipant.show();
    },
    supprimerParticipant(item) {
      const index = this.form.participants.indexOf(item);
      this.form.participants.splice(index, 1);
      if (
        this.form.referent !== null &&
        this.form.referent.id === item.contact.id
      ) {
        this.removeReferent();
      }
    },
    valideNouveauContact(personnePhysique) {
      if (
        this.form.participants
          .flatMap(p => p.contact.id)
          .indexOf(personnePhysique.id) === -1
      ) {
        this.form.participants.push({
          contact: {
            fonction: personnePhysique.fonction,
            id: personnePhysique.id,
            nom: personnePhysique.nom,
            pmid: personnePhysique.idPersonneMorale,
            ppid: personnePhysique.idPersonnePhysique,
            prenoms: personnePhysique.prenoms,
            societe: personnePhysique.raisonSociale,
          },
          typeParticipant: {
            libelle: personnePhysique.type,
            id: personnePhysique.typeId,
          },
          id: null,
        });
        if (personnePhysique.referent === true) {
          this.form.referent.id = personnePhysique.id;
          toasted.info('Contact ajouté comme membre et référent de l\'instance');
        } else {
          toasted.info('Contact ajouté comme membre de l\'instance');
        }
      } else {
        toasted.info('Ce contact est déjà un membre de l\'instance.');
      }
    },

    // Utils
    formatDate(isoDate) {
      if (!isoDate) {
        return null;
      }
      return moment(isoDate).format('DD/MM/YYYY');
    },
    dateRule() {
      if (this.dateDebutFormatted && this.dateFinFormatted) {
        return () =>
          !!(this.dateDebutISO < this.dateFinISO) ||
          'La date de début doit être avant la date de fin';
      }
      return true;
    },
    deleteDateDebut() {
      this.form.dateDebut = null;
    },
    deleteDateFin() {
      this.form.dateFin = null;
    },

    // Export
    exportInstance() {
      var pagination = null;
      const id = [this.form.id];
      var params = {
        ids: id,
        criteres: [
          'nom',
          'description',
          'typeInstance',
          'dateDebut',
          'dateFin',
          'referent',
          'urlSharepoint',
        ],
        format: 'excel',
        taille: 'A3',
      };
      const uri = 'export/instance';
      this.waitForExport = true;
      return this.$api(uri)
        .post(params, { params: pagination, responseType: 'arraybuffer' })
        .then(
          response => {
            this.erreurExport = '';
            const contentType = response.headers.get('content-type');
            const contentDisposition = response.headers.get(
              'content-disposition',
            );
            if (
              contentDisposition &&
              contentDisposition.indexOf('attachment') !== -1
            ) {
              const regex = /filename="([^"]+)"/;
              const match = contentDisposition.match(regex);
              if (match) {
                const blob = new Blob([response.data], { type: contentType });
                saveAs(blob, match[1]);
              } else {
                toasted.error('recherche.export.error.noFilename');
              }
            } else {
              toasted.error('recherche.export.error.noAttachment');
            }
          },
          response => {
            var jsonResponse = arraybufferToResponse(response);
            if (jsonResponse && jsonResponse.status) {
              toasted.error(
                this.$t('recherche.export.error.serverErrorWithStatus', {
                  status: jsonResponse.status,
                }),
              );
            } else {
              toasted.error(this.$t('recherche.export.error.serverError'));
            }
          },
        )
        .finally(() => {
          this.waitForExport = false;
        });
    },
  },
};
</script>
